export enum BotItemStatus {
  INSTALLABLE,
  REMOVABLE,
}
